import { api } from '@/lib/api'
import type { Position, PositionCreate, TaxLot, TaxLotCreate } from '@/types/position'

export async function listPositions(): Promise<Position[]> {
  const { data } = await api.get<Position[]>('/positions/')
  return data
}

export async function createPosition(body: PositionCreate): Promise<Position> {
  const { data } = await api.post<Position>('/positions/', body)
  return data
}

export async function addTaxLot(positionId: number, body: TaxLotCreate): Promise<TaxLot> {
  const { data } = await api.post<TaxLot>(`/positions/${positionId}/tax-lots`, body)
  return data
}

export async function deletePosition(positionId: number): Promise<void> {
  await api.delete(`/positions/${positionId}`)
}
